import { Images } from "../../Assets/Index";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchtoast,
  ExtractDate,
  ExtractTime,
  getLocalStorageItem,
} from "../../Utils";

import { Avatar, DatePicker, Table } from "antd";
import { LiaCitySolid } from "react-icons/lia";
import { PiCity } from "react-icons/pi";
import { IoCaretBack } from "react-icons/io5";
import { FaCalendar } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";
import { useEffect, useState } from "react";
import { getfetchResult } from "./ChartEndpoint";
import { AnimatePresence } from "framer-motion";
import dayjs from "dayjs";
import { getProfile } from "../Profile/UserEndpoints";
const Chart = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const navigate = useNavigate();
  const { profileDetail, setProfileDetail } = useCommmonStore();
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    UserProfile();
  }, []);
  
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 5);

  const formatDate = (date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formatDate(oneWeekAgo));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [resultData, setResultData] = useState([]);

  const columns = [
    {
      title: "Room Id",
      dataIndex: "room_id",
      key: "room_id",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Winner Option",
      dataIndex: "winner_option",
      key: "winner_option",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },

    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {/* {getLocalStorageItem("userDetails")?.name}Chart */}
                Chart
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll h-full">
            {" "}
            <div>
              <div className="m-4 bg-black ">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center rounded-lg mt-6">
                  <div className="ml-4">
                    <p className="text-white custome text-sm">
                      Select Start Date
                    </p>
                    <DatePicker
                      onChange={(val) =>
                        setStartDate(val?.format("YYYY-MM-DD"))
                      }
                      suffixIcon={<FaCalendar className="text-gray-400" />}
                      style={{
                        width: 200,
                        background: "#000",
                        border: "1px solid #d9d9d9",
                        fontFamily: "cursive",
                        color: "#fff",
                      }}
                      className="datepicker-placeholder"
                      disabledDate={(current) =>
                        current && current > dayjs().endOf("day")
                      }
                    />
                  </div>
                  <div className="ml-4">
                    <p className="text-white custome text-sm">
                      Select End Date
                    </p>

                    <DatePicker
                      onChange={(val) => setEndDate(val?.format("YYYY-MM-DD"))}
                      suffixIcon={<FaCalendar className="text-gray-400" />}
                      style={{
                        width: 200,
                        background: "#000",
                        border: "1px solid #d9d9d9",
                        fontFamily: "cursive",
                        color: "#fff",
                      }}
                      className="datepicker-placeholder"
                      format={"DD-MM-YYYY"}
                      disabledDate={(current) => {
                        return (
                          current &&
                          (current < dayjs(startDate, "YYYY-MM-DD") ||
                            current > dayjs().endOf("day"))
                        );
                      }}
                    />
                  </div>
                </div>
                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "desaver_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none bg-pink-600"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Desawar
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Winning Number
                    </p>
                  </div>
                  {/* <p className="service-icon border-none "></p> */}
                </div>

                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "dubai_diamond_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-red-600"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Dubai Market
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Winning Number
                    </p>
                  </div>
                  {/* <p className="service-icon border-none "></p> */}
                </div>

                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "faridabad_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-[#336600]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Faridabad
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Winning Number
                    </p>
                  </div>
                  {/* <p className="service-icon border-none "></p> */}
                </div>
                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "gaziyabaad_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-[#800080]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Ghaziabad
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Results to be announce soon
                    </p>
                  </div>
                  {/* <p className="service-icon border-none ">32</p> */}
                </div>
                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "gali_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-[#000099]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Gali
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Results to be announce soon
                    </p>
                  </div>
                  {/* <p className="service-icon border-none ">32</p> */}
                </div>
                <div
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 bg-gradient-to-tr from-[#7d4403] via-[#222222] to-[#4b2902]
                  items-center rounded-lg mt-6 p-2  border-none"
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "delhi_city_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-[#3973ac]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Delhi City
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Results to be announce soon
                    </p>
                  </div>
                  {/* <p className="service-icon border-none ">32</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chart;
